import CustomerOrderShipmentStatusBadge from 'domains/customer-order/atoms/shipment-status-badge'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import StringUtil from 'utils/string-util'


const propTypes = {
  customerShipment: PropTypes.object
}

/**
 * Multi-purpose Customer Order Shipment view.
 * It display about the shipment information
 * @param {object} customerShipment
 */
const CustomerOrderShipmentView = ({ customerShipment }) => (
  <>
    <div className='d-flex justify-content-between align-items-center mb-2'>
      <strong>{ `Ship No. ${customerShipment.number || 'undentified'}` }</strong>
      <CustomerOrderShipmentStatusBadge status={ customerShipment.status } />
    </div>

    <Table
      hover
      bordered
      size={ 'sm' }
    >
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ customerShipment.id }</td>
        </tr>
        <tr>
          <th scope='row'>Courier</th>
          <td>{ customerShipment.courier }</td>
        </tr>
        <tr>
          <th scope='row'>Service Type</th>
          <td>{ customerShipment.courier_service_type }</td>
        </tr>
        <tr>
          <th scope='row'>Tracking Number</th>
          <td className='text-wrap'>{ customerShipment.tracking_no }</td>
        </tr>
        <tr>
          <th scope='row'>Weight</th>
          <td>{ customerShipment.weight }</td>
        </tr>
        <tr>
          <th scope='row'>Cost</th>
          <td>{ StringUtil.currencyCase(customerShipment.cost) }</td>
        </tr>
        <tr>
          <th scope='row'>Insurance Cost</th>
          <td>{ StringUtil.currencyCase(customerShipment.insurance_cost) }</td>
        </tr>
      </tbody>
    </Table>
  </>
)

CustomerOrderShipmentView.propTypes = propTypes

export default CustomerOrderShipmentView
